import * as tslib_1 from "tslib";
import { IgrCellInfo } from "./igr-cell-info";
import { TextCellModel as TextCellModel_internal } from "./TextCellModel";
/**
 * Backing information for a text cell in the grid.
*/
var IgrTextCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTextCellInfo, _super);
    function IgrTextCellInfo() {
        return _super.call(this) || this;
    }
    IgrTextCellInfo.prototype.createImplementation = function () {
        return new TextCellModel_internal();
    };
    Object.defineProperty(IgrTextCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextCellInfo.prototype, "textValue", {
        /**
         * Sets or gets the text value for the cell.
        */
        get: function () {
            return this.i.ky;
        },
        set: function (v) {
            this.i.ky = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrTextCellInfo;
}(IgrCellInfo));
export { IgrTextCellInfo };
//# sourceMappingURL=igr-text-cell-info.js.map
